/**
 * Kinde authentication configuration
 *
 * Configuration object for KindeProvider that manages Kinde's internal state.
 * Environment variables are loaded via Vite's import.meta.env.
 *
 * @see https://docs.kinde.com/developer-tools/sdks/frontend/react-sdk
 */
export const kindeConfig = {
    clientId: import.meta.env.VITE_KINDE_CLIENT_ID,
    domain: import.meta.env.VITE_KINDE_DOMAIN,
    redirectUri: import.meta.env.VITE_KINDE_REDIRECT_URI,
    logoutUri: import.meta.env.VITE_KINDE_LOGOUT_URI,
    audience: `${import.meta.env.VITE_API_SERVER_URL}/api`,
    scope: 'openid profile email offline',
    useInsecureForRefreshToken: process.env.NODE_ENV !== 'production', // Only allow insecure in development
}
